import { useProtocolStore } from '@/store/protocolStore'
import { useCheckoutStore } from '@/store/checkoutStore'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const PaymentRoute = lazyRouteComponent(() => import('@/features/payment/Payment'), 'Payment')

export const Route = createFileRoute('/pagamento')({
  component: PaymentRoute,
  beforeLoad: () => {
    const { protocol, isCartComplete } = useProtocolStore.getState()
    const { paymentMethod } = useCheckoutStore.getState()

    if (!protocol || !isCartComplete()) {
      throw redirect({ to: '/protocolo' })
    }

    if (!paymentMethod) {
      throw redirect({ to: '/checkout' })
    }
  },
})
